// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AFb5","question":"styles_question__3IWrS","description":"styles_description__1DzLR"};